import React from 'react'
import Header from '../../components/Header/Header'
import StoriesCard from '../../components/Main/StoriesCard'
import CtaBanner from '../../components/Main/CtaBanner'
import Footer from '../../components/Footer/Footer'

import { getWpStorypage, getSomeStories } from '../../data/stories'

export default function Stories (props) {
  const {
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.page.story.acf

  const { stories: storiesPosts } = props.page

  return (
    <React.Fragment>
      <Header
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug='/stories'
      />
      <main id='content' className='events-page'>
        <div className='stories'>
          <StoriesCard storiesPosts={storiesPosts} page={props.page} />
        </div>

      </main>
      <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      <Footer />
    </React.Fragment>
  )
}

export async function getStaticProps ({ preview = false }) {
  const page = {
    story: await getWpStorypage(),
    stories: await getSomeStories()
  }

  return {
    props: {
      page
    }
  }
}
